export const checkboxPreset = {
  checkbox: {
    root: {
        borderRadius: '6px',
        hoverBorderColor: 'var(--brand--50)',
        checkedBackground: 'var(--brand--50)',
        checkedHoverBackground: 'var(--brand--60)',
        checkedBorderColor: 'var(--brand--50)',
        checkedHoverBorderColor: 'var(--brand--60)',
        checkedFocusBorderColor: 'var(--brand--60)',
        disabledBackground: 'var(--neutral--20)',
        checkedDisabledBorderColor: 'var(----20)',
        focusBorderColor: 'var(--brand--50)',
        focusRing: {
            width: '3px',
            color: 'rgba(21, 93, 252, 0.12)',
            offset: '0rem',
            style: 'solid',
        },
    },
    icon: {
      size: '0.8rem',
      disabledColor: 'var(--neutral--50)',
    },
  },
};
